import {
  QueryFunction,
  QueryKey,
  useQuery,
  UseQueryOptions,
} from '@tanstack/react-query';
import { App } from 'antd';
import { handleError, PaginatedRequestParams } from 'api';
import { LogApiService } from 'features/log/api/log-api.services';
import qs from 'qs';

import { LogQueryKeys } from './query-keys';
const { getActivityLogHistory } = LogApiService();
export interface ActivityLogParams extends PaginatedRequestParams {
  actionType?: string;
  stationCode?: string;
  stationName?: string[];
  transactionRemark?: string;
}

const getUsersQuery = (
  params: any,
  options?: UseQueryOptions<any>,
): {
  queryKey: QueryKey;
  queryFn: QueryFunction<any>;
  options?: UseQueryOptions<any>;
} => ({
  queryKey: LogQueryKeys.list(params),
  queryFn: ({ signal }) =>
    getActivityLogHistory(params, {
      config: {
        signal,
        paramsSerializer: {
          serialize: (queryParams) =>
            qs.stringify(queryParams, {
              arrayFormat: 'repeat',
              encode: true,
            }),
        },
      },
    }),
  ...options,
});

export const useGetLogActivityList = (
  params: ActivityLogParams,
  options?: UseQueryOptions<any>,
) => {
  const { message } = App.useApp();
     
  return useQuery<any, Error>(
    getUsersQuery(params, {
      onError: (error: unknown) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      ...options,
    }),
  );
};








